import { useGetControlsResourceCount } from "api/generated/controls/controls";

import { CONTROL_LIST_QUERY_OPTIONS } from "./controlListQueryOptions";

export function useControlsResourceCountQuery() {
    return useGetControlsResourceCount({
        query: {
            ...CONTROL_LIST_QUERY_OPTIONS,
            select: (response) => response.data,
        },
    });
}
